//live
const API_URL = "https://api.reachemchemicals.com/api/v1/website/";
const BASE_URL = "https://api.reachemchemicals.com/";
// //local
// const API_URL = "http://localhost:6600/api/v1/website/";
// const BASE_URL = "http://localhost:6600/";
const WEB_URL = "https://www.reachemchemicals.com/";
const COMPANY_CODE = "";
const CURRENCY = "Rs";

export { API_URL, BASE_URL, COMPANY_CODE, CURRENCY,WEB_URL };